import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetData_importBatches = z.any()
export type TagsGetData_importBatches = z.infer<typeof tagsGetData_importBatches>

export const responseGetData_importBatches = z.object({ "payload": z.object({ "batches": z.array(z.object({ "id": z.string(), "kind": z.union([z.literal("readings"), z.literal("invoices")]), "filename": z.string(), "fileFormat": z.string(), "createdAt": z.string(), "createdBy": z.string(), "sourceHash": z.string(), "undoneAt": z.union([z.string(), z.null()]), "summary": z.object({ "rows": z.number().int(), "newRecords": z.number().int(), "duplicates": z.number().int(), "newBuildings": z.number().int(), "newCollectionPoints": z.number().int(), "errors": z.number().int() }) })) }).optional(), "errors": z.any(), "message": z.string().optional() })
export type ResponseGetData_importBatches = z.infer<typeof responseGetData_importBatches>

interface IGetData_importBatches extends BaseMethodType {
  tags: TagsGetData_importBatches,
  response: ResponseGetData_importBatches
}
export const URL = '/data-import/batches'
export const validation = {
  get: {
    tags: tagsGetData_importBatches,
    response: responseGetData_importBatches
  }
}
export interface Data_importBatches extends BaseRouteType {
  get: IGetData_importBatches
}